module.exports = __webpack_public_path__ + "static/img/SUSTAINABILITY.260c9541.jpg";